import React from "react";

const ChevronRightIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5.99993 4.47367C5.73993 4.73367 5.73993 5.15367 5.99993 5.41367L8.5866 8.00034L5.99993 10.587C5.73993 10.847 5.73993 11.267 5.99993 11.527C6.25993 11.787 6.67993 11.787 6.93993 11.527L9.99993 8.46701C10.2599 8.20701 10.2599 7.78701 9.99993 7.52701L6.93993 4.46701C6.6866 4.21367 6.25993 4.21367 5.99993 4.47367Z" fill="#4F4A4A"/>
  </svg>
);

export default ChevronRightIcon;
